export default __webpack_public_path__ + "static/look-1-alt-5b39b6f67af8f621f13da8a559c10e16.png";